import { useMutation } from '@tanstack/react-query';

import { errorHandler } from '../helpers';
import { $api } from '../service';

export const useSendComment = () =>
  useMutation({
    mutationFn: async (comment: { comment?: string; rating?: number; ticket_id?: string }) => {
      const { data } = await $api.post('/comment', comment);

      return data;
    },
    onError: errorHandler()
  });
